import { render, staticRenderFns } from "./formmask.vue?vue&type=template&id=d66d0268&scoped=true&lang=html"
import script from "./formmask.vue?vue&type=script&lang=js"
export * from "./formmask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66d0268",
  null
  
)

export default component.exports